import { render, staticRenderFns } from "./CharacteristicProperties.vue?vue&type=template&id=2413fe50&"
import script from "./CharacteristicProperties.vue?vue&type=script&lang=js&"
export * from "./CharacteristicProperties.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicProperties.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports